import { isProd } from './env';

export function getApiBaseUrl() {
  if (isProd) {
    return 'https://www.alo-inc.com/service';
  }

  return 'http://localhost:5000/service';
}
